import { api } from "@/lib/api";

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function pushPermission() {
  return pushSupported() ? Notification.permission : "unsupported";
}

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function isPushEnabled() {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration("/push-sw.js");
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch {
    return false;
  }
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Notifications aren't supported on this browser");

  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications permission was blocked");

  const { key } = await api.pushVapidKey();
  if (!key) throw new Error("Push isn't configured on the server");

  const reg = await navigator.serviceWorker.register("/push-sw.js", { scope: "/" });
  await navigator.serviceWorker.ready;

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(key),
    });
  }
  const json = sub.toJSON();
  if (!json.endpoint || !json.keys || !json.keys.p256dh || !json.keys.auth) {
    throw new Error("Browser returned an incomplete subscription");
  }
  await api.pushSubscribe({ endpoint: json.endpoint, keys: json.keys });
  return true;
}

export async function disablePush() {
  if (!pushSupported()) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration("/push-sw.js");
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      try { await api.pushUnsubscribe({ endpoint: sub.endpoint }); } catch {}
      await sub.unsubscribe();
    }
  } catch {
    /* best-effort */
  }
}
